import moment from 'moment'
import { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MultipleSquares } from 'shared/components/icon-pack/icons'
import { SocketContext } from 'shared/contexts/socket/socket-context'
import {
  resetRingingData,
  selectOperator,
  setHangup,
  setIsRinging,
} from 'store/slice/call-detail/call-detail.slice'
import { RootState } from 'store/store'

import { HangupEventType } from '../../../types/hangup-event.type'

type PropType = {
  phoneNumber: string
  startDate: string | null
}

const CallNumberAndDuration = (props: PropType) => {
  const { startDate, phoneNumber } = props
  const [duration, setDuration] = useState<string>('')
  const socket = useContext(SocketContext)
  const phoneCallId = useSelector(
    (state: RootState) => state.callDetail.callData.phoneCallId
  )
  const dispatch = useDispatch()

  useEffect(() => {
    const momentStartDate = moment(startDate)
    const _intervalId = setInterval(() => {
      if (startDate) {
        const durationInSec = moment().diff(momentStartDate, 'second')
        const minutes = Math.floor(durationInSec / 60)
          .toString()
          .padStart(2, '0')
        const seconds = (durationInSec % 60).toString().padStart(2, '0')
        setDuration(`${minutes}:${seconds}`)
      }
    }, 1000)

    const hangUpCallback = (event: HangupEventType) => {
      console.log('hangup:', event)
      if (_intervalId && event.phoneCallId === phoneCallId) {
        clearInterval(_intervalId)
        dispatch(setHangup(true))
        dispatch(setIsRinging(false))
        dispatch(resetRingingData())
        dispatch(selectOperator(null))
      }
    }

    socket?.on('hangup', hangUpCallback)

    return () => {
      if (_intervalId) {
        clearInterval(_intervalId)
      }
      socket?.off('hangup', hangUpCallback)
    }
  }, [startDate, phoneCallId])

  return (
    <div className="flex items-center justify-between px-4 py-3 mb-6 bg-white rounded-4">
      <div className="flex items-center">
        <MultipleSquares className="w-6 h-6" />
        <p className="mr-2 text-[#3639A6] font-medium text-sm leading-4.5 ">
          {phoneNumber || 'نامشخص'}
        </p>
      </div>
      <div className="flex items-center">
        <p className="ml-3 text-base font-semibold leading-9 text-[#939597]">
          {duration}
        </p>
      </div>
    </div>
  )
}

export default CallNumberAndDuration
